import React from 'react';
import { theme } from '../styles';
import { personalInfo } from '../data';

const Navigation = ({ currentPage, setCurrentPage, isMobile, isMenuOpen, setIsMenuOpen }) => {
  const pages = ['home', 'about', 'projects', 'skills', 'contact'];
  
  const pageLabels = {
    home: 'Accueil',
    about: 'À Propos',
    projects: 'Projets',
    skills: 'Compétences',
    contact: 'Contact'
  };

  return (
    <nav style={styles.nav}>
      <div style={{
        ...styles.navContainer,
        padding: isMobile ? '1rem' : '1rem 2rem',
      }}>
        {/* Logo */}
        <div 
          style={styles.logo}
          onClick={() => setCurrentPage('home')}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === 'Enter' && setCurrentPage('home')}
        >
          <span style={styles.logoAccent}>{'<'}</span>
          {personalInfo.initials}
          <span style={styles.logoAccent}>{'/>'}</span>
        </div>

        {/* Desktop Menu */}
        {!isMobile && (
          <div style={styles.desktopMenu}>
            {pages.map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  ...styles.navLink,
                  ...(currentPage === page ? styles.navLinkActive : {}),
                }}
              >
                {pageLabels[page]}
              </button>
            ))}
          </div>
        )}

        {/* Mobile Menu Button */}
        {isMobile && (
          <button
            style={styles.menuButton}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <div style={{
              ...styles.menuLine,
              transform: isMenuOpen ? 'rotate(45deg) translateY(8px)' : 'none',
            }} />
            <div style={{
              ...styles.menuLine,
              opacity: isMenuOpen ? 0 : 1,
            }} />
            <div style={{
              ...styles.menuLine,
              transform: isMenuOpen ? 'rotate(-45deg) translateY(-8px)' : 'none',
            }} />
          </button>
        )}
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && isMobile && (
        <div style={styles.mobileMenu}>
          {pages.map((page) => (
            <button
              key={page}
              onClick={() => {
                setCurrentPage(page);
                setIsMenuOpen(false);
              }}
              style={{
                ...styles.mobileNavLink,
                ...(currentPage === page ? styles.navLinkActive : {}),
              }}
            >
              {pageLabels[page]}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

const styles = {
  nav: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    background: 'rgba(10, 15, 28, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderBottom: '1px solid rgba(0, 217, 255, 0.1)',
  },
  navContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    fontSize: '1.5rem',
    fontWeight: '700',
    fontFamily: theme.fonts.mono,
    color: theme.colors.text,
    cursor: 'pointer',
    transition: theme.transition.normal,
  },
  logoAccent: {
    color: theme.colors.primary,
  },
  desktopMenu: {
    display: 'flex',
    gap: '0.5rem',
  },
  navLink: {
    background: 'transparent',
    border: 'none',
    color: theme.colors.textMuted,
    padding: '0.75rem 1.25rem',
    fontSize: '0.95rem',
    fontWeight: '500',
    cursor: 'pointer',
    borderRadius: '8px',
    transition: theme.transition.normal,
    fontFamily: theme.fonts.main,
  },
  navLinkActive: {
    color: theme.colors.primary,
    background: 'rgba(0, 217, 255, 0.1)',
  },
  menuButton: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '10px',
    minHeight: '44px',
    minWidth: '44px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  menuLine: {
    width: '24px',
    height: '2px',
    background: theme.colors.primary,
    transition: theme.transition.normal,
    borderRadius: '2px',
  },
  mobileMenu: {
    padding: '0.5rem 1rem 1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    borderTop: '1px solid rgba(0, 217, 255, 0.1)',
    background: 'rgba(10, 15, 28, 0.98)',
  },
  mobileNavLink: {
    background: 'transparent',
    border: 'none',
    color: theme.colors.textMuted,
    padding: '1rem',
    fontSize: '1rem',
    fontWeight: '500',
    cursor: 'pointer',
    borderRadius: '8px',
    textAlign: 'left',
    transition: theme.transition.normal,
    fontFamily: theme.fonts.main,
    minHeight: '48px',
  },
};

export default Navigation;
